import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon: IconComponent, name, ...props }) => {
  // Priority: 1. Passed component 2. Named lookup 3. Fallback
  const FinalIcon = IconComponent || (name ? FiIcons[`Fi${name}`] : null) || FiAlertTriangle;
  
  try {
    return <FinalIcon {...props} />;
  } catch (e) {
    return <FiAlertTriangle {...props} />;
  }
};

export default SafeIcon;